// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import {
  CheckIcon,
  CopyIcon,
  Flex,
  SelectField,
  Typography,
} from '@iheartjane/reefer';
import { useState } from 'react';

import { useFetchBloomMenus } from '@jane/business-admin/data-access';

interface MenuSelectorProps {
  currentMenuId?: string;
  onChange: (newId: string) => void;
}

const StyledTypography = styled(Typography)(() => ({
  textDecoration: 'underline',
  textDecorationStyle: 'dashed' as const,
  textUnderlineOffset: '6px',
  textDecorationColor: 'var(--colors-grays-mid)',
  cursor: 'pointer',
}));

export const MenuSelector = ({
  currentMenuId,
  onChange,
}: MenuSelectorProps) => {
  const { data: bloomMenus } = useFetchBloomMenus();

  const currentMenuToken = bloomMenus?.find(
    (menu) => menu.id === Number(currentMenuId)
  )?.menu_token;

  const [showCopied, setShowCopied] = useState(false);

  const copyMenuToken = () => {
    if (currentMenuToken) {
      navigator.clipboard.writeText(currentMenuToken);
      setShowCopied(true);
    }
    setTimeout(() => {
      setShowCopied(false);
    }, 1000);
  };

  return (
    <Flex flexDirection="column" mb={40}>
      <SelectField
        mt={24}
        ml={40}
        mr={40}
        name="bloom-menus"
        label="bloom-menus"
        labelHidden
        required
        value={currentMenuId}
        onChange={onChange}
        options={(bloomMenus ?? []).map(({ menu_url, id }) => ({
          label: `${menu_url}`,
          value: `${id}`,
        }))}
      />
      <Flex
        flexDirection="row"
        mt={8}
        justifyContent="space-between"
        ml={40}
        mr={40}
      >
        <Typography as="p" color="grays-mid" mr={16}>
          Token: {currentMenuToken}
        </Typography>
        <Flex onClick={copyMenuToken} aria-label="Copy menu token">
          {showCopied ? <CheckIcon /> : <CopyIcon />}
          <StyledTypography ml={8} color="grays-dark">
            Copy token
          </StyledTypography>
        </Flex>
      </Flex>
    </Flex>
  );
};
